module.exports = __webpack_public_path__ + "static/media/auth-background.0cdaa462.jpg";